import Button from '@/components/Button'
import Icon from '@/components/Icon'
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/sharp-solid-svg-icons'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import styles from './InstagramFeed.module.scss'

// Only needed once photos have loaded, so keep Swiper out of the page bundle
const InstagramSlider = dynamic(() => import('./InstagramSlider'), { ssr: false })

export default function InstagramFeed() {
  const [photos, setPhotos] = useState([])

  useEffect(() => {
    const fetchInstagramPhotos = async () => {
      try {
        const response = await fetch('/api/faust/instagram')
        if (!response.ok) throw new Error('Failed to fetch Instagram photos')

        const data = await response.json()
        setPhotos(data)
      } catch (err) {
        console.log(err.message)
      }
    }

    fetchInstagramPhotos()
  }, [])

  const displayPosts = photos.data || []

  return (
    <div className={styles.instagramFeed}>
      <div className="container">
        <div className={styles.photoFeed}>
          <h2 data-aos="fade-up">Life at Integrity</h2>
          <Button href="https://www.instagram.com/integrity_xd/" target="_blank">
            View All posts <Icon icon={faArrowRight} />
          </Button>
        </div>
        <div id="contentSwiper">{displayPosts.length > 0 && <InstagramSlider posts={displayPosts} />}</div>
        <div className="prev">
          <Icon icon={faChevronLeft} />
        </div>
        <div className="next">
          <Icon icon={faChevronRight} />
        </div>
      </div>
    </div>
  )
}
